module.exports = __webpack_public_path__ + "public/1.0.1_896977/img/attention.69a22f8e.svg";